import React from 'react';
import {
  DropdownButton,
  MenuItem,
  Panel,
  Col,
  FormControl,
  Form,
  FormGroup,
  ControlLabel,
} from 'react-bootstrap';

import Modal from 'react-bootstrap/lib/Modal';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Button from 'react-bootstrap/lib/Button';
import Popover from 'react-bootstrap/lib/Popover';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import s from './AddHotelModal.scss';

import withStyles from 'isomorphic-style-loader/lib/withStyles';

const turistObjTypes = [
  "Agroturystyka", "Hostel", "Hotel", "Kemping/Pole namiotowe",
  "Kwatera prywatna/mieszkanie", "Motel", "Pokój gościnny", "Ośrodek wczasowy/pensjonat",
  "Sanatorium", "Schronisko młodzieżowe", "Schronisko turystyczne", "Zajazd", "Inny obiekt noclegowy"
];
const propertyNames = ["id", "typ", "nazwa_pelna", "opis", "opis_pelny", "wlasnosc", "jezyk",
  "miejscowosc", "ulica", "nr_budynku", "nr_lokalu", "kod_pocztowy", "dlugosc_geogr", "szerokosc_geogr",
  "telefon", "email", "strona_www", "symbol", "licz_miejsc_nocleg", "liczba_pokoi", "pokoje_jednoos_licz",
  "pokoje_jednoos_cena", "pokoje_dwuos_licz", "pokoje_dwuos_cena", "pokoje_trzyos_licz", "pokoje_trzyos_cena",
  "pokoje_czteroos_licz", "pokoje_czteroos_cena", "pokoje_piecioos_licz", "pokoje_piecioos_wieksz_cena",
  "apartamenty_licz", "apartamenty_cena", "rodzaje_pokoi", "caloroczny_sezonowy", "godz_zakwaterowania",
  "godz_wykwaterowania", "godz_pracy_recepc", "dodatk_recepcja", "podst_udogod", "podst_dla_gosci",
  "zdrowie_relaks", "wyzywienie", "dodatk_wyzywienie", "sport_rozrywka", "rodzina_dzieci", "biznes", "uslugi",
  "motoryzacyjne", "inne_udogod_uslugi", "x", "geom", "y", "nu_id"
  ];
const displayableNames = ["id", "Typ", "Nazwa pełna", "Opis", "Opis pełny", "Własność", "Język",
  "Miejscowość", "Ulica", "Numer budynku", "Numer lokalu", "Kod pocztowy", "Długość geogr", "Szerokość geogr",
  "Telefon", "E-mail", "Strona www", "Symbol", "Liczba miejsc noclegowych", "Liczba pokoi",
  "Pokoje jednoosobowe - liczba", "Pokoje jednoosobowe - cena", "Pokoje dwuosobowe liczba",
  "Pokoje dwuosobowe - cena", "Pokoje trzyosobwe liczba", "Pokoje trzyosobowe - cena",
  "Pokoje czteroosobowe - liczba", "Pokoje czteroosobowe - cena", "Pokoje pięcioosobowe - liczba",
  "Pokoje pięcioosobowe większe - cena", "Apartamenty - liczba", "Apartamenty - cena", "Rodzaje pokoi",
  "Całoroczny sezonowy", "Godzina zakwaterowania", "Godzina wykwaterowania", "Godziny pracy recepcji",
  "Dodatkowa recepcja", "Podstawowe udogodnienia", "Podst dla gości", "Zdrowie relaks", "Wyżywienie",
  "Dodatkowe wyżywienie", "Sport rozrywka", "Rodzina dzieci", "Biznes", "Usługi",
  "Motoryzacyjne", "Inne udogodnienia usługi", "x", "geom", "y", "nu_id"];
const notAllowedIndexes = [0, 12, 13, 52, 51, 50, 49]

const filteredDisplayableNames = displayableNames.filter(
  (item, index) => {
    return index !== notAllowedIndexes.find(i => i === index
    )
  }
).slice(4)
const filteredPropertyNames = propertyNames.filter(
  (item, index) => {
    return index !== notAllowedIndexes.find(i => i === index
    )
  }
).slice(4)

class AddHotelModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      curTyp: "Agroturystyka",
      formValues: {},
      remainingFields: filteredDisplayableNames,
      chosenFields: [],
      remainingPropertyNames: filteredPropertyNames,
      chosenPropertyNames: [],
    };
  }

  onChangeType = (e) => {
    this.setState({ curTyp: e.target.value });
  }

  onChangeFormControl = (e, controlName) => {
    this.setState({
      formValues: {
        ...this.state.formValues,
        [controlName]: e.target.value.length > 0 ? e.target.value : null,
      },
    });
  }

  onSelectAddItem = (e) => {
    let selectedValue = this.state.remainingFields.find(
      (item, index) => { return index === e - 1 }
    )
    this.setState({
      chosenFields: this.state.chosenFields.concat(selectedValue),
      remainingFields: this.state.remainingFields.filter(
        item => { return item !== selectedValue }
      )
    });
    let selectedPropertyName = this.state.remainingPropertyNames.find(
      (item, index) => { return index === e - 1 }
    )
    this.setState({
      chosenPropertyNames: this.state.chosenPropertyNames.concat(selectedPropertyName),
      remainingPropertyNames: this.state.remainingPropertyNames.filter(
        item => { return item !== selectedPropertyName }
      )
    });
  }
  handleRemove = itemName => {
    this.setState({
      remainingFields: this.state.remainingFields.concat(itemName),
      chosenFields: this.state.chosenFields.filter(
        item => { return item !== itemName }
      ),
      remainingPropertyNames: this.state.remainingPropertyNames.concat(itemName),
      chosenPropertyNames: this.state.chosenPropertyNames.filter(
        item => { return item !== itemName }
      ),
    })
  }
  prepareData = () => {
    // prepare data
    let currentState = this.state.formValues;
    currentState['typ'] = this.state.curTyp;
    return currentState;
  }

  render() {

    const dataItemsMapped = this.state.remainingFields.map(
      (item, index) => <MenuItem value={index} eventKey={index + 1} key={index}>{item}</MenuItem>
    );

    return (
      <Modal show={this.props.showModal} onHide={this.props.onClose}>
        <Modal.Body>
          <div className="row">
            <div className="col-xs-12">
              <div className={"form-wrap"}>
                <h1>Utwórz nowy obiekt hotel</h1>

                <Panel header={<h3>Rodzaj obiektu</h3>}>
                  <Form horizontal>
                    <FormGroup controlId="formHorizontalTyp">
                      <Col componentClass={ControlLabel} sm={4}>
                        Typ:
                      </Col>
                      <Col sm={8}>
                        <FormControl
                          ref={(control) => { this.catControl = control; }}
                          onChange={(e) => this.onChangeType(e)}
                          value={this.state.curTyp}
                          componentClass="select">
                          {turistObjTypes.map((value, index) => {
                            return <option value={value} key={index}>{value}</option>
                          })}
                        </FormControl>
                      </Col>
                    </FormGroup>
                  </Form>
                </Panel>

                <Panel header={<h3>Dane obiektu</h3>} className="panel panel-warning">
                  <Form horizontal>

                    <FormGroup controlId="formHorizontalkategoria">
                      <Col componentClass={ControlLabel} sm={4}>
                        Nazwa pełna:
                      </Col>
                      <Col sm={8}>
                        <FormControl className="text" placeholder="..." onChange={(e) => this.onChangeFormControl(e, 'nazwa_pelna')} />
                      </Col>
                    </FormGroup>

                    <FormGroup controlId="formHorizontalTyp">
                      <Col componentClass={ControlLabel} sm={4}>
                        Opis:
                      </Col>
                      <Col sm={8}>
                        <FormControl componentClass="input" placeholder="..." onChange={(e) => this.onChangeFormControl(e, 'opis')} />
                      </Col>
                    </FormGroup>

                    <FormGroup controlId="formHorizontalTyp">
                      <Col componentClass={ControlLabel} sm={4}>
                        Pełny opis:
                      </Col>
                      <Col sm={8}>
                        <FormControl componentClass="textarea" placeholder="..." onChange={(e) => this.onChangeFormControl(e, 'opis_pelny')} />
                      </Col>
                    </FormGroup>

                    {this.state.chosenPropertyNames.map(
                      (item, index) =>
                        <FormGroup controlId="formHorizontalKod" key={index}>
                          <Col componentClass={ControlLabel} sm={4}>
                            {this.state.chosenFields[index]}
                          </Col>
                          <Col sm={6}>
                            <FormControl className="input" placeholder="....." onChange={(e) => this.onChangeFormControl(e, item )} />
                          </Col>
                          <Col sm={2}>
                            <Button onClick={() => this.handleRemove(item)}><span className="buttonX glyphicon glyphicon-remove-sign" ></span></Button>
                          </Col>
                        </FormGroup>
                      )
                    }

                    <FormGroup controlId="formHorizontalButtons">
                      <Col smOffset={4} sm={8}>
                        <DropdownButton
                          dropup
                          onSelect={(value) => this.onSelectAddItem(value)}
                          title="Dodaj właściwość&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
                          className={"btn btn-custom btn-lg btn-block"}
                          id="dataDropdownButton">
                          {dataItemsMapped}
                        </DropdownButton>
                      </Col>
                    </FormGroup>

                  </Form>
                </Panel>

                <FormGroup controlId="formHorizontalButtons">
                  <Col sm={6}>
                    <input
                    onClick={this.props.onClose}
                    type="submit"
                    id="btn-login"
                    className={"btn btn-custom btn-lg btn-block"}
                    value="Anuluj" />
                  </Col>
                  <Col sm={6}>
                    <input
                    type="submit"
                    id="btn-login"
                    onClick={() => this.props.onHotelSubmit(this.prepareData())}
                    className={"btn btn-custom btn-lg btn-block"}
                    value="Dodaj Hotel" />
                  </Col>
                </FormGroup>

              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default withStyles(s)(AddHotelModal);



// WEBPACK FOOTER //
// src/components/Modals/AddHotelModal/AddHotelModal.js